import React, { Component } from 'react'
import { injectIntl, intlShape } from 'react-intl'
import Select from 'react-select';
//import * as R from 'ramda'

import './ShopifyProduct.css';

class ShopifyProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      variantID: null,
      variantLabel: null
    }
  }

  componentDidMount() {
    const firstVariant = this.props.product.variants[0];

    this.setState({variantID: firstVariant.id, variantLabel: firstVariant.optionValues[0].value});
  }

  render() {
    const product = this.props.product;

    let variants = [];

    let i;
    for(i=0; i<product.variants.length; i++) { 
      let variant = product.variants[i].attrs.variant;

      variants.push({ value: variant.id, label: variant.option_values[0].value });
    }

    let t = this;

    let variantObject = product.variants.filter(function(obj) {
      return obj.id === t.state.variantID;
    })[0];

    return (
      <div className="shopify-product">
        <div>
          <header>
            <h3>{product.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: product.description }} />
          </header>

          <footer>
            <label>{this.props.intl.messages["webshop.chooseValue"]}</label>
            <div className="select-wrapper">
              <Select
                name="product-variant"
                value={{ value: this.state.variantID, label: this.state.variantLabel }}
                clearable={false}
                searchable={false}
                openOnFocus={true}
                options={variants}
                onChange={(e) => this.setState({variantID: e.value, variantLabel: e.label})}
              />
            </div>
            <span className="btn add-to-cart" onClick={() => this.props.addVariantToCart(variantObject,1)}>{this.props.intl.messages["webshop.addToCart"]}</span>
          </footer>
        </div>
      </div>
    )
  }
}

ShopifyProduct.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ShopifyProduct)



// WEBPACK FOOTER //
// ./src/components/Shopify/ShopifyProduct.js